import { Button, Checkbox, FormControlLabel, Grid, InputAdornment, Typography } from "@mui/material"
import LoginImg from "../../assets/img/login register.png"
import { CellphoneMaskCustom, CEPMaskCustom, CNPJMaskCustom, CPFMaskCustom } from "../../components/mask"
import { InputComponent } from "../../components/input"
import { useEffect, useState } from "react"
import { SelectComponent } from "../../components/select"
import { Controller, useForm } from "react-hook-form"
import { Utils, Validators } from "../../utils"
import { DatePicker } from "@mui/x-date-pickers"
import { CgCalendarToday } from "react-icons/cg";
import { LoadingButton } from "@mui/lab"
import moment, { Moment } from "moment"
import useRegister, { IRegisterData } from "../../context/register"
import { ExternalService } from "../../services/external"
import { SessionStorage } from "../../storage"
import { ClientsService } from "../../services/clients"
import animationPassword from "../../assets/animation/passoword.json"
import Lottie from 'react-lottie'
import { useLocation, useNavigate } from "react-router-dom"
import useAuth from "../../context/auth"
import { useQueryParams } from "../../hooks"

const First = ({ isClient }: { isClient?: boolean }) => {
    const { nextStep, loading, setLoading } = useRegister()

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
        setError,
        clearErrors
    } = useForm<{ cnpj: string }>()

    const handleNextStep = ({
        cnpj
    }: { cnpj: string }) => {
        setLoading(true)

        ClientsService.getCNPJ(cnpj)
            .then(({ data }) => {
                console.log(data?.message)
                if (data?.status === "ERROR") {
                    setError("cnpj", {
                        message: data?.message
                    })
                } else {
                    clearErrors("cnpj")

                    nextStep({
                        first: {
                            cnpj,
                            partners: data?.qsa?.filter((q: { nome: string, qual: string }) => ["49-Sócio-Administrador", "16-Presidente", "05-Administrador", "65-Titular-Pessoa-Física-Residente-ou-Domiciliado-no-Brasil", "50-Empresário"].includes(q.qual))?.map((q: { nome: string, qual: string }) => q.nome)
                        }
                    })
                }
            })
            .catch((err) => {
                setError("cnpj", {
                    message: err?.response?.data?.message ?? "Houve um erro inesperado. Tente novamente em alguns minutos."
                })
            })
            .finally(() => setLoading(false))
    }

    return (
        <Grid
            container
            sx={{
                width: "100%",
                height: "calc(100vh - 100px)",
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "nowrap",
            }}
        >
            <img
                src={LoginImg}
                style={{
                    width: "100%",
                    background: "linear-gradient(180deg, rgba(97, 173, 240, 0.2) 0%, rgba(0, 136, 255, 0.2) 84.4%, rgba(255, 255, 255, 0.2) 100%)",
                    padding: "8rem 0px 1rem",
                    marginTop: "-8rem"
                }}
            />
            <Grid
                width={"85%"}
                display={"flex"}
                direction={"column"}
                alignItems={"center"}
                gap={"2rem"}
                pb={"2rem"}
            >
                <Grid
                    width={"90%"}
                >
                    <Typography
                        fontSize={"3.2rem"}
                        fontWeight={700}
                        textAlign={"start"}
                    >
                        {isClient ? "Cadastro" : "Cadastro de Parceiro"}
                    </Typography>

                    <Typography
                        fontSize={"1.6rem"}
                        fontWeight={400}
                        textAlign={"start"}

                        sx={{
                            opacity: .5
                        }}
                    >
                        Informe seu CNPJ
                    </Typography>
                </Grid>

                <InputComponent
                    type="text" // Necessário para a máscara funcionar
                    inputMode="numeric"
                    value={watch("cnpj") || ""}
                    onChangeValue={(value) => setValue("cnpj", value, { shouldValidate: true })}
                    label="CNPJ"
                    placeholder="00.000.000/0000-00"
                    mask={CNPJMaskCustom}
                    error={!!errors.cnpj}
                    helperText={errors.cnpj?.message}

                    {...register("cnpj", {
                        required: {
                            value: true,
                            message: "Informe seu CNPJ",
                        },
                    })}

                />

                <LoadingButton
                    variant="contained"
                    onClick={handleSubmit(handleNextStep)}
                    loading={loading}
                    sx={{
                        background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                    }}
                >
                    Continuar
                </LoadingButton>
            </Grid>
        </Grid>
    )
}

const Second = ({ isClient }: { isClient?: boolean }) => {
    type HookFormData = { name: string, cpf: string, birthday: Moment | null, agree: boolean }

    const { partners, nextStep, loading, setLoading } = useRegister()
    const { handleModal } = useAuth()
    const navigate = useNavigate()

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
        control
    } = useForm<HookFormData>()

    const selectedName = watch("name")
    const hasAgree = watch("agree")

    const [disableSelectName, setDisableSelectName] = useState(false)

    const handleNextStep = async ({
        birthday,
        cpf,
        name
    }: HookFormData) => {
        setLoading(true)
        const { first } = await SessionStorage.getRegisterData()

        ClientsService.verifyEnterpriseOwnerShip({
            cnpj: Utils.onlyDigits(first?.cnpj as string),
            cpf: Utils.onlyDigits(cpf),
            birthday: (birthday as Moment).format("YYYY-MM-DD")
        })
            .then(() => {
                nextStep({
                    second: {
                        birthday: (birthday as Moment).format("DD/MM/YYYY"),
                        cpf,
                        name
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                const code = err?.response?.data?.point
                const message = err?.response?.data?.message
                const blockCodes = ["E0006", "E0005", "E0002", "Z0001"]
                const loginCodes = ["C001"]
                handleModal(true, {
                    message,
                    type: "error",
                    callback: () => {
                        if (blockCodes.includes(code)) {
                            sessionStorage.clear()
                            navigate("/", {
                                state: {
                                    notAllowed: true
                                }
                            })
                            window.location.reload()
                        }
                        if (loginCodes.includes(code)) {
                            sessionStorage.clear()
                            navigate("/cliente")
                            window.location.reload()
                        }
                    }
                })
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (partners.length === 1) {
            setValue("name", partners[0])
            setDisableSelectName(true)
        }
    }, [])


    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "5rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "20px",
                flexWrap: "nowrap",
            }}
        >
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2.5,
                    alignItems: "center",
                    width: "100%"

                }}
            >
                <Typography
                    variant="h1"
                    textAlign={"left"}
                    width={"90%"}
                >Sócio administrador</Typography>

                <Typography
                    variant="body1"
                    sx={{ opacity: .5 }}
                    textAlign={"left"}
                    width={"90%"}
                >Selecione o sócio administrador para continuar o cadastro</Typography>

                <SelectComponent
                    {...register("name", {
                        required: true
                    })}
                    label="Sócio Administrador"
                    options={partners.map((name) => ({
                        label: name,
                        value: name
                    }))}
                    value={selectedName || ""}
                    disabled={disableSelectName}
                />

                {selectedName && <>
                    <InputComponent
                        label="CPF do sócio administrador"
                        mask={CPFMaskCustom}
                        value={watch("cpf") || ""}
                        onChangeValue={(value) => setValue("cpf", value, { shouldValidate: true })}
                        error={!!errors.cpf}
                        helperText={errors.cpf?.message}
                        {...register("cpf", {
                            required: {
                                value: true,
                                message: "Informe o CPF do sócio administrador",
                            },
                            validate: (value) => {
                                if (!Validators.validateCPF(value)) {
                                    return "CPF inválido!";
                                }
                            },
                        })}
                    />

                    <Controller
                        name="birthday"
                        control={control}
                        defaultValue={null} // Valor inicial vazio
                        rules={{
                            required: "Informe a Data de nascimento", // Validação de campo obrigatório
                        }}
                        render={({ field }) => (
                            <DatePicker
                                label="Data de nascimento"
                                value={field.value} // Valor gerenciado pelo Controller
                                onChange={(newValue) => field.onChange(newValue)} // Atualiza o valor no Controller
                                slotProps={{
                                    textField: {
                                        error: !!errors.birthday, // Exibe o estado de erro
                                        helperText: errors.birthday?.message, // Mensagem de erro
                                        InputProps: {
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CgCalendarToday size={20} />
                                                </InputAdornment>
                                            ),
                                        },
                                    },
                                }}
                            />
                        )}
                    />

                </>}

            </Grid>

            {selectedName && <Grid
                container
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                    alignItems: "center",
                }}
            >
                <FormControlLabel
                    control={<Checkbox {...register("agree", {
                        required: true
                    })} />}
                    label={<>Confirmo que sou <strong>{selectedName}</strong></>}
                    sx={{
                        width: "90%",
                        ml: 1
                    }}
                    disabled={loading}
                />
                <LoadingButton
                    variant="contained"
                    disabled={!hasAgree}
                    onClick={handleSubmit(handleNextStep)}
                    loading={loading}
                >
                    Continuar
                </LoadingButton>
            </Grid>}
        </Grid>
    )
}

const Third = ({ isClient }: { isClient?: boolean }) => {

    type HookFormData = {
        street: string,
        number: string,
        district: string,
        city: string,
        cep: string,
        uf: string,
        complement?: string,
        reference?: string,
        email: string,
        phone: string
    }

    const { nextStep, getData, loading, setLoading } = useRegister()
    const { state } = useLocation()
    const [prevData, setPrevData] = useState<IRegisterData | null>(null)
    const { c, p } = useQueryParams()

    const [loadingCEP, setLoadingCEP] = useState(false)


    useEffect(() => {
        const loadData = async () => {
            const data = await getData();
            setPrevData(data);
        };
        loadData();
    }, []);

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
        control,
        setError,
        clearErrors
    } = useForm<HookFormData>()

    const handleNextStep = async ({
        cep,
        city,
        district,
        number,
        street,
        uf,
        complement,
        reference,
        email,
        phone
    }: HookFormData) => {
        setLoading(true)
        const { first, second } = await SessionStorage.getRegisterData()

        if (isClient) {
            ClientsService.create({
                cnpj: Utils.onlyDigits(first?.cnpj as string),
                cpf: Utils.onlyDigits(second?.cpf as string),
                email: email,
                data: {
                    birthday: moment(second?.birthday, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    phone: Utils.onlyDigits(phone),
                    address: {
                        cep: Utils.onlyDigits(cep),
                        city,
                        district,
                        number,
                        street,
                        uf,
                        complement,
                        reference
                    }
                },
                createAsBlocked: state?.hasFailed,
                indicatedBy: p ?? c
            })
                .then(({ data }) => {
                    console.log(data)
                    nextStep({
                        fourth: {
                            token: data.token,
                            role: data?.user?.role,
                            userId: data?.user?.uuid
                        }
                    })
                })
                .finally(() => setLoading(false))
        } else {
            ClientsService.createPartner({
                cnpj: Utils.onlyDigits(first?.cnpj as string),
                cpf: Utils.onlyDigits(second?.cpf as string),
                email: email,
                data: {
                    birthday: moment(second?.birthday, "DD/MM/YYYY").format("YYYY-MM-DD"),
                    phone: Utils.onlyDigits(phone),
                },
                indicatedBy: p
            })
                .then(({ data }) => {
                    console.log(data)
                    nextStep({
                        fourth: {
                            token: data.token,
                            role: data?.user?.role,
                            userId: data?.user?.uuid
                        }
                    })
                })
                .finally(() => setLoading(false))
        }
    }

    const cepValue = watch("cep");

    useEffect(() => {
        if (cepValue?.length === 9) {
            setLoadingCEP(true)

            getCEP(cepValue)
        }
    }, [cepValue]);

    const getCEP = (cep: string) => {
        ExternalService.getCEP(cep)
            .then(({ data }) => {

                if (data?.erro) {
                    setError("cep", {
                        message: "CEP inválido!"
                    })
                    setValue("uf", "")
                    setValue("city", "")
                    return
                } else {
                    clearErrors("cep")
                }
                console.log(data)
                if (data?.uf && data?.uf !== "") {
                    setValue("uf", data?.uf)
                    clearErrors("uf")
                }

                if (data?.localidade && data?.localidade !== "") {
                    setValue("city", data?.localidade)
                    clearErrors("city")
                }
            })
            .finally(() => setLoadingCEP(false))
    }

    return (
        <Grid
            container
            sx={{
                height: "100%",
                display: "flex",
                gap: "1rem",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >
            <Typography
                variant="h1"
                textAlign={"left"}
                width={"90%"}
            >Informações de cadastro</Typography>

            <Typography
                variant="body1"
                sx={{ opacity: .5 }}
                textAlign={"left"}
                width={"90%"}
            >Precisamos de mais algumas informações sobre você para concluir seu cadastro</Typography>

            {isClient &&
                <>
                    <Typography
                        variant="body1"
                        sx={{ fontWeight: 400, margin: "1rem 0rem" }}
                        textAlign={"left"}
                        width={"90%"}
                    >Endereço de <strong>{prevData?.second?.name}</strong></Typography>

                    <InputComponent
                        autoFocus
                        label="CEP"
                        mask={CEPMaskCustom}
                        value={watch("cep") || ""}
                        onChangeValue={(value) => setValue("cep", value, { shouldValidate: true })}
                        error={!!errors.cep}
                        helperText={errors.cep?.message}
                        loading={loadingCEP}
                        disabled={loading}
                        {...register("cep", {
                            required: {
                                value: isClient,
                                message: "Informe o CEP",
                            },
                        }
                        )}
                    />

                    <InputComponent
                        label="Cidade"
                        value={watch("city") || ""}
                        onChangeValue={(value) => setValue("city", value, { shouldValidate: true })}
                        error={!!errors.city}
                        helperText={errors.city?.message}
                        disabled
                        {...register("city", {
                            required: {
                                value: isClient,
                                message: "Informe um CEP válido para preencher a Cidade",
                            },
                        }
                        )}
                    />

                    <InputComponent
                        label="Estado"
                        value={watch("uf") || ""}
                        onChangeValue={(value) => setValue("uf", value, { shouldValidate: true })}
                        error={!!errors.uf}
                        helperText={errors.uf?.message}
                        disabled
                        {...register("uf", {
                            required: {
                                value: isClient,
                                message: "Informe um CEP válido para preencher o Estado",
                            },
                        }
                        )}
                    />

                    <InputComponent
                        label="Endereço completo"
                        value={watch("street") || ""}
                        onChangeValue={(value) => setValue("street", value, { shouldValidate: true })}
                        error={!!errors.street}
                        helperText={errors.street?.message}
                        disabled={loading}
                        {...register("street", {
                            required: {
                                value: isClient,
                                message: "Informe o seu Endereço completo",
                            },
                        }
                        )}
                    />

                    <InputComponent
                        label="Número"
                        value={watch("number") || ""}
                        onChangeValue={(value) => setValue("number", value, { shouldValidate: true })}
                        error={!!errors.number}
                        helperText={errors.number?.message}
                        disabled={loading}
                        {...register("number", {
                            required: {
                                value: isClient,
                                message: "Informe o seu Número",
                            },
                        }
                        )}
                    />

                    <InputComponent
                        label="Complemento/Referência (opcional)"
                        value={watch("complement") || ""}
                        onChangeValue={(value) => setValue("complement", value, { shouldValidate: true })}
                        error={!!errors.complement}
                        helperText={errors.complement?.message}
                        disabled={loading}
                        {...register("complement")}
                    />

                    <InputComponent
                        label="Bairro"
                        value={watch("district") || ""}
                        onChangeValue={(value) => setValue("district", value, { shouldValidate: true })}
                        error={!!errors.district}
                        helperText={errors.district?.message}
                        disabled={loading}
                        {...register("district", {
                            required: {
                                value: isClient,
                                message: "Informe o seu Bairro",
                            },
                        }
                        )}
                    />
                </>
            }

            <Typography
                variant="body1"
                sx={{ fontWeight: 400, margin: "1rem 0rem" }}
                textAlign={"left"}
                width={"90%"}
            >Contato de <strong>{prevData?.second?.name}</strong></Typography>

            <InputComponent
                label="E-mail"
                value={watch("email") || ""}
                onChangeValue={(value) => setValue("email", value, { shouldValidate: true })}
                error={!!errors.email}
                helperText={errors.email?.message}
                disabled={loading}
                {...register("email", {
                    required: {
                        value: true,
                        message: "Informe seu E-mail"
                    },
                    validate: (value) => {
                        if (!Validators.validateEmail(value)) {
                            return "E-mail inválido!";
                        }
                    },
                })}
            />


            <InputComponent
                label="WhatsApp"
                value={watch("phone") || ""}
                onChangeValue={(value) => setValue("phone", value, { shouldValidate: true })}
                error={!!errors.phone}
                helperText={errors.phone?.message}
                disabled={loading}
                mask={CellphoneMaskCustom}
                {...register("phone", {
                    required: {
                        value: true,
                        message: "Informe seu WhatsApp"
                    },
                    validate: (value) => {
                        if (!Validators.validateWhatsAppNumber(value)) {
                            return "WhatsApp inválido!";
                        }
                    },
                })}
            />

            <LoadingButton
                onClick={handleSubmit(handleNextStep)}
                variant="contained"
                loading={loading}
            >
                Continuar
            </LoadingButton>

        </Grid>
    )
}
const Fourth = ({ isClient }: { isClient?: boolean }) => {
    const navigate = useNavigate()
    const { getData } = useRegister()
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationPassword,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "2rem",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >
            <div style={{ width: 240, height: 240 }}>
                <Lottie options={defaultOptions} />
            </div>
            <Typography variant="h1">Quase lá!</Typography>

            <Typography variant="body1" textAlign={"center"} sx={{ opacity: 0.5 }}>Para concluir o seu cadastro é necessário que clique no botão abaixo e cadastre uma senha de acesso para a plataforma Gyroo.</Typography>

            <Button variant="contained" sx={{ animation: "pulse 1.5s infinite" }} onClick={async () => {
                const data = await getData()
                navigate(`/${isClient ? "cliente" : "parceiro"}/primeiro-acesso?t=${data.fourth?.token}&u=${data.fourth?.userId}&r=${data.fourth?.role}`)
            }}>Cadastrar senha</Button>
        </Grid>
    )
}

export const Steps = [
    First,
    Second,
    Third,
    Fourth
]